import styled from 'styled-components';

export const PropertiesTypesListWrap = styled.div`
    display: block;
    width: 100%;
    overflow: auto;
`;
